<template>
   <div id="idFiltrosClientesExtraCostosModal">
        <Button
            :size="15"
            color="#FD9137"
            colorText="#ffffff"
            tooltip="Filtrar"
            icon="fas fa-filter"
            round
            :width="30"
            class="mr-2"
            traslate
            @click.native="actionSetShowModalFilterClienteExtraCostoModal(true)"
        />

        <ui-modal 
            ref="modal" 
            title="Filtros Clientes Extra Costo"
            size="large"
            @close="actionSetShowModalFilterClienteExtraCostoModal(false)"
        >
            <div class="container-fluid">
                <div class="row">
                    <div class="col-6">
                        <ui-select
                            class="w-100"
                            has-search
                            label="Clientes"
                            placeholder = "Seleccionar"
                            searchPlaceholder ="Buscar"
                            :options = "clientsList"
                            v-model="id_client"
                            :keys="selectFormat"
                        />
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <ui-select
                            class="w-100"
                            has-search
                            label="Tipo Extra Costo"
                            placeholder = "Seleccionar"
                            searchPlaceholder ="Buscar"
                            :options = "extraCostTypes"
                            v-model="id_extra_costos_tipo"
                            :keys="selectFormat"
                        />
                    </div>
                     <div class="col">
                        <ui-select
                            class="w-100"
                            has-search
                            label="Proveedor"
                            placeholder = "Seleccionar"
                            searchPlaceholder ="Buscar"
                            :options = "listCarriers"
                            v-model="id_carrier"
                            :keys="selectFormat"
                        />
                     </div>
                </div>

                <div class="row">
                    <div class="col">
                        <ui-select
                            class="w-100"
                            has-search
                            label="Moneda"
                            placeholder = "Seleccionar"
                            searchPlaceholder ="Buscar"
                            :options = "listCurrencies"
                            v-model="id_currency"
                            :keys="selectFormat"
                        />
                    </div>

                    <div class="col">
                        <ui-select
                            class="w-100"
                            label="Tipo contenedor"
                            hasSearch
                            searchPlaceholder="Buscar"
                            placeholder="Seleccionar opción"
                            :keys="selectFormat"
                            :options="containerTypes"
                            v-model="id_container_type"
                        />
                    </div>
                </div>

                <div class="row mt-3">
                    <div class="col ">
                        <date-picker
                            placeholder="Desde"
                            type="date"
                            class="w-100"
                            value-type="format"
                            v-model="from"

                        />
                    </div>

                    <div class="col">
                        <date-picker
                            placeholder="Hasta"
                            type="date"
                            class="w-100"
                            value-type="format"
                            v-model="to"

                        />
                    </div>
                </div>

                <div class="row">
                    <div class="col mt-4">

                        <Button
                            v-if="showBtnExporterClienteExtraCostoModal"
                            text="Exportar"
                            :width="120"
                            :height="40"
                            class="float-right ml-3"
                            color="#21831b"
                            colorText="#fff"
                            icon="far fa-paper-plane"
                            title="Exportar a Excel"
                            horizontal
                            :inactive="btnAction"
                            @click.native="generateReport"

                        />
                        <Button
                            v-else
                            text="Filtrar"
                            :width="120"
                            :height="40"
                            class="float-right ml-3"
                            color="#21831b"
                            colorText="#fff"
                            icon="far fa-paper-plane"
                            title="Filtrar"
                            horizontal
                            :inactive="btnAction"
                            @click.native="filter"

                        />

                        <Button
                            text="Limpiar"
                            :width="120"
                            :height="40"
                            class="float-right"
                            color="#21831b"
                            colorText="#fff"
                            icon="far fa-trash-alt"
                            title="Limpiar"
                            horizontal
                            :inactive="btnAction"
                            @click.native="clear"
                        />

                        <Button
                            text="Cerrar"
                            :width="120"
                            :height="40"
                            class="float-left"
                            color="#21831b"
                            colorText="#fff"
                            icon="fa fa-times"
                            title="Cerrar"
                            horizontal
                            @click.native="actionSetShowModalFilterClienteExtraCostoModal(false)"
                            :inactive="btnAction"
                        />
                    </div>
                </div>
            </div>
        </ui-modal>
   </div>

</template>

<script>

    // UI Modal
    import UiModal from "keen-ui/src/UiModal";
    import Button from '@/components/common/Button.vue';
    import { mapState, mapActions } from "vuex";
    import DatePicker from "vue2-datepicker";
    import { tariffClientsExtraCostoExport, tariffClientsExtraCostoFilter } from "../../../../constants/serviciosLogisticos";
    import { downloadFile } from "../../../../mixins";

    export default {

        data(){
            return{
                selectFormat : { value: 'id', label: 'name' },
                id_client : {},
                id_extra_costos_tipo: {},
                id_carrier: {},
                id_currency: {},
                id_container_type: {},
                from: "",
                to: "",

                btnAction : false
            }
        },
        components: {
            UiModal,
            Button,
            DatePicker
        },

        computed: {
            ...mapState("serviciosLogisticos", [
                "clientsList",
                "listCarriers",
                "listCurrencies",
                "extraCostTypes",
                "unityPayments",
                "showLoadingUpdateProviderExtraCost",
                "showBtnExportProviderExtraCost",
                "containerTypes",
                "showModalFilterClienteExtraCostoModal",
                "showBtnExporterClienteExtraCostoModal"
            ])
        },

        methods : {
            ...mapActions([ "ActionSetZindexTablaModal"]),

            
            ...mapActions("serviciosLogisticos", [
                "actionSetShowBtnExporterClienteExtraCostoModal",
                "actionSetShowModalFilterProviderExtraCost",
                "actionSetDataTableClienteExtraCosto",
                "actionSetShowModalFilterClienteExtraCostoModal"
            ]),

            openModal(ref) {
                this.ActionSetZindexTablaModal(true);
                this.$refs[ref].open();
            },
            
            closeModal(ref) {
                this.ActionSetZindexTablaModal(false);
                this.$refs[ref].close();
                this.actionSetShowBtnExporterClienteExtraCostoModal( false );
            },
            cerrarModal(){
                this.closeModal('modal');
            },
            clear(){
                this.id_extra_costos_tipo = {} ;
                this.id_carrier = {} ;
                this.id_currency = {} ;
                this.id_container_type = {} ;
                this.id_client = {} ;
                this.from = "" ;
                this.to = "" ;
            },
            generatePayload(){

                return {
                    id_client : this.id_client.id ?? null,
                    id_extra_costos_tipo : this.id_extra_costos_tipo.id ?? null,
                    id_carrier : this.id_carrier.id ?? null,
                    id_currency : this.id_currency.id ?? null,
                    id_container_type : this.id_container_type.id ?? null,
                    from : ! this.from ? null : this.from ,
                    to   : ! this.to   ? null : this.to
                }
            },  
            async filter(){

                this.btnAction = true ;
                const payload = this.generatePayload() ;

                try {
                    this.$vToastify.loader("Filtrando...");
                
                    const { data } = await tariffClientsExtraCostoFilter( payload ) ;

                    this.actionSetDataTableClienteExtraCosto( data );

                    this.$vToastify.stopLoader() ;

                    this.btnAction = false ;
                    return this.actionSetShowModalFilterClienteExtraCostoModal( false ) ;

                } catch (error) {
                    this.btnAction = false ;

                    this.$vToastify.stopLoader();
                    return this.$vToastify.error("Hubo un problema al intentar filtrar datos. Favor, recargue la página y vuelva a intentar.", "Error");
                };
            },

            async generateReport(){

                this.btnAction = true ;

                const payload = this.generatePayload() ;

                try {
                    this.$vToastify.loader("Exportando...");

                    const { data } = await tariffClientsExtraCostoExport( payload ) ;

                    this.$vToastify.stopLoader() ;

                    this.btnAction = false ;

                    downloadFile( data , 'tariff_client_extra_cost.xlsx' ) ;


                } catch (error) {
                    this.btnAction = false ;

                    this.$vToastify.stopLoader();

                    return this.$vToastify.error("Hubo un problema al generar reporte. Favor, recargue la página y vuelva a intentar.", "Error");
                };

                
            }
        },
        watch: {
            showModalFilterClienteExtraCostoModal : function ( _new ){
                _new ? this.openModal("modal") : this.cerrarModal() ;
            }
        }

    }

</script>

<style>

#idFiltrosClientesExtraCostosModal .mx-input {
    padding-left: 2px !important;
    border-radius: 0 !important;
    border: none !important;
    border-bottom: 1px solid #dcdcdc !important;
    box-shadow: none !important;
}
</style>